import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import { Row, Col } from "reactstrap";

import { api_GET } from "services/api_service";
import { showMessage } from "services/message";
import { table_translate, table_style } from "constants/MaterialTable.js";
import { formateDateandTime } from "helpers/formats";

// Histórico das conclusões feitas pelo requerente após a reprova pelo gestor (CE-4367).
// A seção só é exibida quando o requerimento possui registros.
const HistoricoAlteracoesUsuario = ({ requerimento_Id }) => {
  const [historico, set_historico] = useState([]);

  useEffect(() => {
    if (!requerimento_Id) return undefined;

    let ativo = true;
    api_GET("requerimento/GetHistoricoAlteracoesUsuario/" + requerimento_Id)
      .then((result) => {
        if (ativo) set_historico(Array.isArray(result?.data) ? result.data : []);
      })
      .catch((err) => {
        if (ativo) showMessage("Aviso", err.message, "error", null);
      });

    return () => {
      ativo = false;
    };
  }, [requerimento_Id]);

  if (historico.length === 0) return null;

  return (
    <Row className="mt-4">
      <Col lg="12">
        <h3 className="titulo-consulta">Histórico de Alterações do Usuário</h3>
        <div className="line-protocolo"></div>
      </Col>

      <MaterialTable
        style={{ minHeight: "auto", width: "100%" }}
        title=""
        columns={[
          {
            title: "Data e Hora da Alteração",
            field: "dataHora",
            render: (rowData) => formateDateandTime(rowData.dataHora),
          },
          { title: "Usuário", field: "nomeUsuario" },
          { title: "Observação", field: "observacao" },
        ]}
        data={historico}
        isLoading={false}
        localization={table_translate}
        options={table_style}
      />
    </Row>
  );
};

export default HistoricoAlteracoesUsuario;
